<style lang="scss" scoped>
.full-page {
  width: calc(100% + 40px);
  margin: 0 -20px;
  height: 100%;
  height: calc(100vh - 73px);
  overflow: hidden;
  .title-bar {
    padding: 0 32px !important;
    box-shadow: inset 0 -1px 0 0 #ededed;
    display: flex;
    .title {
      max-width: 300px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding: 20px 32px 20px 0;
    }
    ::v-deep .box {
      border-right: 1px solid #ededed;
      border-left: 1px solid #ededed;
      padding: 0 25px;
      display: flex;
      align-items: center;
      justify-content: center;
      i {
        height: 20px;
        width: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      &.clickable {
        cursor: pointer;
        transition: color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        &:hover {
          color: var(--primary);
        }
        &.open {
          box-shadow: inset 0px -3px 0 0px var(--primary);
        }
      }
    }
  }
  .content {
    height: 100%;
    height: calc(100% - 62px);
    display: flex;
    flex-flow: row;
    .side {
      width: 570px;
      height: 100%;
      overflow-y: auto;
      overflow-x: hidden;
    }
    .preview {
      width: calc(100% - 570px);
      background: #f4f5f7;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      .scrollable {
        overflow-x: hidden;
        overflow-y: auto;
        padding: 40px;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>

<template>
  <div class="row">
    <div class="header-spacer"></div>
    <div class="full-page position-relative">
      <div class="title-bar">
        <slot name="title-bar"></slot>
      </div>
      <div class="content">
        <div class="side p-30">
          <slot name="side-bar"></slot>
        </div>
        <div class="preview">
          <div class="scrollable">
            <template-content :data="data" :value="{ answers: [] }"></template-content>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TemplateContent from '@/components/elements/templates/template-content';

export default {
  components: {
    TemplateContent,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>
